import React from 'react';
import { LayoutContent } from './Layout.dumb';
import 'src/styles/style.css';

const Layout: React.FC = ({ children }) => {
	return <LayoutContent>{children}</LayoutContent>;
};

export default Layout;
